export class DomainError extends Error {
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
  }
}

export class InvariantViolation extends DomainError {
  constructor(
    public readonly aggregate: string,
    public readonly invariant: string,
    detail?: string,
  ) {
    super(
      detail
        ? `${aggregate} invariant violated: ${invariant} — ${detail}`
        : `${aggregate} invariant violated: ${invariant}`,
    );
  }
}

export class IllegalStateTransition extends DomainError {
  constructor(
    public readonly aggregate: string,
    public readonly from: string,
    public readonly to: string,
    public readonly trigger: string,
  ) {
    super(`${aggregate}: illegal transition ${from} → ${to} on "${trigger}"`);
  }
}

export class AuthDeniedError extends DomainError {
  constructor(public readonly idTag: string) {
    super(`Authorization denied for idTag ${JSON.stringify(idTag)}`);
  }
}

export class TransactionRecoveryError extends DomainError {
  constructor(message: string) {
    super(message);
  }
}

export class UnknownConnectorError extends DomainError {
  constructor(public readonly connectorId: number) {
    super(`Unknown connector id: ${connectorId}`);
  }
}

export class UnknownEvseError extends DomainError {
  constructor(public readonly evseId: number) {
    super(`Unknown EVSE id: ${evseId}`);
  }
}
